export enum ELanguage {
  EN_US = 'en-US',
  ZH_HANS = 'zh-Hans',
}
